import { render, staticRenderFns } from "./host-common-messageAccount.vue?vue&type=template&id=71f0e752&scoped=true&"
import script from "./host-common-messageAccount.vue?vue&type=script&lang=js&"
export * from "./host-common-messageAccount.vue?vue&type=script&lang=js&"
import style0 from "./host-common-messageAccount.vue?vue&type=style&index=0&id=71f0e752&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0e752",
  null
  
)

export default component.exports